import { H5, CheckboxField } from '@wheely/ui-kit';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { updateIsVehiclesHidden } from '@/modules/partner/actions/async/updateIsVehiclesHidden';
import { IPartner } from '@/modules/partner/model';
import { AppDispatch } from '@/root-store';

import s from './styles.module.css';

interface IProps {
  partner: IPartner;
}

const Settings = ({ partner }: IProps) => {
  const dispatch = useDispatch() as AppDispatch;

  const [error, setError] = useState<string | null>(null);

  const handleCheckboxChange = useCallback(
    async (event: React.FormEvent<HTMLInputElement>) => {
      setError(null);

      const { result = {} } = await dispatch(
        updateIsVehiclesHidden({ isVehiclesHidden: !event.currentTarget.checked }),
      ).unwrap();

      if (result.baseErrors?.[0]) {
        setError(result.baseErrors?.[0]);
      }
    },
    [dispatch],
  );

  return (
    <div className={s.root}>
      <H5 capitalize={true} className={s.title}>
        <FormattedMessage
          defaultMessage="Settings"
          id="D7Ew06"
          description="Profile screen: Settings title"
        />
      </H5>
      <CheckboxField
        inline={true}
        name="isAllowToChooseVehicles"
        onChange={handleCheckboxChange}
        checked={!partner.isVehiclesHidden}
        error={error}
      >
        <FormattedMessage
          defaultMessage="Allow chauffeurs to choose vehicle"
          id="VjPKYY"
          description="Checkbox: Allow chauffeurs to choose vehicle"
        />
      </CheckboxField>
    </div>
  );
};

export { Settings };
